module.exports = __webpack_public_path__ + "media/images/steps/svg/215-promotion-2-165362085d418dcbc0f2ff894e7b2602.svg";